const keyframes = `
@keyframes blurAnimation {
  0% { backdrop-filter: blur(100px); }
  25% { backdrop-filter: blur(70px); }
  50% { backdrop-filter: blur(50px); }
  75% { backdrop-filter: blur(70px); }
  100% { backdrop-filter: blur(100px); }
}
`;

const keyframesFlipImages = `
@keyframes flipImages {
  0%, 24% { transform: scaleX(1) scaleY(1); }
  25%, 49% { transform: scaleX(-1) scaleY(1); }
  50%, 74% { transform: scaleX(-1) scaleY(-1); }
  75%, 99% { transform: scaleX(1) scaleY(-1); }
  100% { transform: scaleX(1) scaleY(1); }
}
`;

if (typeof document !== "undefined") {
  const styleSheet = document.styleSheets[0];
  styleSheet.insertRule(keyframes, styleSheet.cssRules.length);
  styleSheet.insertRule(keyframesFlipImages, styleSheet.cssRules.length);
}

export default {};
